"use client"
import React from 'react'
function page() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 text-center max-w-md w-full">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">   
          Thank you!  
        </h1>
          <p className="text-gray-600 mb-6">
          Your submission has been received. We’ll get back to you shortly.
        </p>
        <button
          onClick={() => window.location.href = '/'}
          className="bg-purple-500 text-white px-6 py-2 rounded-lg hover:bg-purple-900 transition"
        >
          Go Back Home
        </button>
        </div>  
    </div>
  )
}

export default page
